import React from 'react';
import logo from './logo.svg';
import './App.css';
import Radio from "./pages/Radio";

function App() {
  return (
    <div className="App">
      <Radio />
    </div>
  );
}

export default App;
